<template>
  <div class="home">
    <div class="error" v-if="error">
      {{ error }}
    </div>
    <div v-if="documents">
      <ListView :playlists="documents" />
    </div>
    <div v-else class="spinners">
      <loading />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import getCollection from "@/composable/getCollection";
import ListView from "@/components/ListView";

import loading from "@/components/loading.vue";

export default {
  name: "HomeView",
  components: {
    ListView,
    loading,
  },
  setup() {
    const { error, documents } = getCollection("playlist");

    return {
      error,
      documents,
    };
  },
};
</script>
<style scoped>
ListView {
  max-width: 90%
}
</style>